import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const PRICING_PRIVACY_VOCABULARIES = [
    vocabulary('pooling.mode', '@vello/api-client PoolMode', {
        off: L('Desligado', 'Off', 'Desactivado', 'Disattivato'),
        shadow: L('Em teste (sombra)', 'Shadow test', 'En prueba (sombra)', 'In prova (ombra)'),
        pilot: L('Piloto', 'Pilot', 'Piloto', 'Pilota'),
        active: L('Ativo', 'Active', 'Activo', 'Attivo'),
    }),
    vocabulary('pricing_automation.decision', '@vello/api-client AutomationDecisionValue', {
        APPLY: L('Aplicada', 'Applied', 'Aplicada', 'Applicata'),
        HOLD: L('Mantida', 'Held', 'Mantenida', 'Mantenuta'),
    }),
    vocabulary('privacy.data_rights_kind', '@vello/api-client DataRightsKind', {
        EXPORT: L('Exportação de dados', 'Data export', 'Exportación de datos', 'Esportazione dei dati'),
        ERASURE: L('Exclusão de dados', 'Data erasure', 'Eliminación de datos', 'Cancellazione dei dati'),
    }),
    vocabulary('privacy.data_rights_status', '@vello/api-client DataRightsStatus', {
        REQUESTED: L('Solicitada', 'Requested', 'Solicitada', 'Richiesta'),
        PROCESSING: L('Em processamento', 'Processing', 'En proceso', 'In elaborazione'),
        COMPLETED: L('Concluída', 'Completed', 'Completada', 'Completata'),
        PARTIALLY_RETAINED: L('Concluída com retenção parcial', 'Completed with partial retention', 'Completada con retención parcial', 'Completata con conservazione parziale'),
        SUPERSEDED: L('Substituída', 'Superseded', 'Sustituida', 'Sostituita'),
    }),
    vocabulary('privacy.data_rights_channel', '@vello/api-client DataRightsChannel', {
        APP: L('Aplicativo', 'App', 'Aplicación', 'App'),
        PUBLIC_PAGE: L('Página pública', 'Public page', 'Página pública', 'Pagina pubblica'),
        OPERATOR: L('Operador', 'Operator', 'Operador', 'Operatore'),
        LEGACY: L('Legado', 'Legacy', 'Heredado', 'Legacy'),
    }),
    vocabulary('privacy.retention_reason', '@vello/api-client RetentionReason', {
        HOLD: L('Bloqueio de retenção', 'Retention hold', 'Bloqueo de retención', 'Blocco di conservazione'),
        FINANCIAL_OBLIGATION: L('Obrigação financeira', 'Financial obligation', 'Obligación financiera', 'Obbligo finanziario'),
        SAFETY_OBLIGATION: L('Obrigação de segurança', 'Safety obligation', 'Obligación de seguridad', 'Obbligo di sicurezza'),
        LEGAL_OBLIGATION: L('Obrigação legal', 'Legal obligation', 'Obligación legal', 'Obbligo legale'),
        RETENTION_NOT_ELAPSED: L('Prazo de retenção ainda não venceu', 'Retention period not over yet', 'El plazo de retención aún no venció', 'Il periodo di conservazione non è ancora scaduto'),
    }),
    vocabulary('product.kind', '@vello/api-client ProductKind', {
        category_product: L('Produto de categoria', 'Category product', 'Producto de categoría', 'Prodotto di categoria'),
        ride_capability: L('Capacidade de corrida', 'Ride capability', 'Capacidad de viaje', 'Capacità di corsa'),
        trip_product: L('Produto de viagem', 'Trip product', 'Producto de viaje', 'Prodotto di viaggio'),
    }),
];
//# sourceMappingURL=pricing-privacy.js.map